import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, OnChanges, ViewEncapsulation, TemplateRef, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Location } from '@angular/common'
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { GeneralLedgerService } from '../../services/general-ledger.service';
import { OrdersService } from '../../services/orders.service';
import { CustomerService } from '../../services/customer.service';
import { PaymentsService } from '../../services/payments.service';
import { PrintService } from '../../services/print.service';
import { VendorService } from '../../services/vendor.service';
import { DocumentIntakeService, ExtractedMemo, GroupMode } from '../../services/document-intake.service';
import { MultipagePromptComponent, MultipagePromptResult } from '../multipage-prompt/multipage-prompt.component';
import { MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';

import { MatTableDataSource } from '@angular/material/table';
import { combineLatest, of, Subject } from 'rxjs';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import { resolveDefaultBankAccountCode } from '../../utils/bank-account-default';

@Component({
	selector: 'app-payment',
	templateUrl: './payment.component.html',
	styleUrls: ['./payment.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotateY(-179deg)'
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		])
	]
})
export class PaymentComponent implements OnInit, OnDestroy {
	@Input() customer: any = [];
	@Output() updatePayments: EventEmitter < any > = new EventEmitter();

	@ViewChild('thirdparty') thirdpartyRef: ElementRef;
	@ViewChild('journal_details') journal_detailsRef: ElementRef;
	@ViewChild('checkno') checknoElement: ElementRef;

	@ViewChild('confirmPdf', { static: true }) confirmPdfRef: TemplateRef < any > ;
	@ViewChild('refundablesForm') refundablesFormRef: ElementRef;

	flip = 'inactive';
	payment_methods: any = [];
	journal_payments: any = [];
	bankaccounts: any = [];
	today = new Date();
	day_payments: any = [];
	paymentForm: UntypedFormGroup;
	cardForm: UntypedFormGroup;
	refundablesForm: UntypedFormGroup;
	selectedCard = new UntypedFormControl('');
	searchByAmount = new UntypedFormControl('');
	searchByInvoice = new UntypedFormControl('');
	searchString = new UntypedFormControl('');
	customerSearchInline = new UntypedFormControl('');
	customerSearchResultsTwo: any = [];
	searchByCurrentPayments = new UntypedFormControl('');
	searchByCurrentInvoices = new UntypedFormControl('');

	selectAllPayments = new UntypedFormControl(false);
	selectAllInvoices = new UntypedFormControl(false);
	selectInvoiceToPay = new UntypedFormControl(false);

	searchByCurrentPaymentsDate = new UntypedFormControl('');
	searchByCurrentInvoicesDate = new UntypedFormControl('');
	holdReason = new UntypedFormControl('');
	journal_review = new UntypedFormControl('');

	alldebits: any = false;
	allcredits: any = false;

	//reversed
	singleusecard = new UntypedFormControl(true);
	selected_card = new UntypedFormControl(false);

	currency: any = '';
	currencies: any = [];
	company: any = [];

	//paymentss
	datefrom = new Date()
	dateto = new Date()
	running = false;
	total_pay: any = '';
	payments: any = [];

	customersearching: any = false;
	customerSearchResults: any = [];
	// Vendor-backed settlement — typed-search results for the inline autocompletes
	naVendorResults: any[] = [];
	naDispensarySummary: { open_rows: number, open_balance: number, vendor_name: string, dispensary_name: string } | null = null;
	naVendorSearchSub: any = null;
	private naEnabledSub: any = null;
	/** Settlement-ref duplicate guard. apir/payments::create throws (rolling the whole
	 *  payment back, AR receipt included) when the reference is already on a live vendor
	 *  credit — CR0002530717 got booked twice that way. Check it as the operator types so
	 *  the clash shows up in the field instead of on submit. */
	naDupCredit: { transno?: string, amount?: number, trandate?: string, reference?: string } | null = null;
	naDupChecking = false;
	private naRefCheck$ = new Subject<{ vendor: string, reference: string }>();
	private naRefCheckSub: any = null;
	/** The (vendor, reference) the in-flight lookup was fired for — a result that no longer
	 *  matches the panel (field cleared, vendor swapped) is dropped rather than applied. */
	private naRefCheckFor: { vendor: string, reference: string } | null = null;
	naAllGlAccounts: any[] = [];
	naGlResults: any[] = [];
	naCommGlResults: any[] = [];
	glOverrideResults: any[] = [];
	private naReliefManual = false;
	/** True once the operator types a commission directly — relief then derives from it. */
	private naCommissionManual = false;
	/** True once the operator hand-edits the receipt amount — stops "Select Invoices To Pay" from overwriting it. */
	private amountManual = false;
	private selectInvoiceBeforeNa = false;
	/** Vendor terms source for AP invoice/due date prepopulation. */
	naSelectedVendor: any = null;
	amountResults: any = false;
	invoiceResults: any = false;
	customertransactions: any = [];

	hasprofile = false;
	payment_added: any = false;
	addingcard: any = false;

	allocations_from: any = [];
	allocations_to: any = [];

	allocation_from_total = 0.00;
	allocation_to_total = 0.00;
	profile_cards: any = [];

	payment_card: any = false;
	single_use: any = false;
	editingcard: any = false;
	sending: any = false;
	color = 'blue';
	charge_card = true;
	submitting = false;
	chargetype = 'existing_card';
	chargecardtype = 'no_charge';
	card_required = false;
	thirdpartylinks: any = false;
	showrefunds = false;
	urlSafe: SafeResourceUrl;
	creditsSelected: any = [];
	expandedElement: any = false;
	hidepay: any = false;
	debitsSelected: any = [];
	refundablePayments: any = [];
	refundableColumns: string[] = [
		'trandate', 'transno', 'card', 'amount', 'status', 'age', 'response_id'
	];
	refundableSelectIndex = -1;
	filteredRefundablePayments: any = [];
	refundablePaymentSearch = new FormControl('');
	isSearching = false;
	refundablesLoading = false;

	allpayments: any = [];
	alltransactions: any = [];

	/**
	 * Brand column + Brand filter on the invoice pay-list (MOOV). Gated on config
	 * `arBrandFilter` — the same flag the Customer Transactions grid and the Over Due
	 * Customers widget use, so the three screens turn on together.
	 *
	 * Options are the brands actually on THIS customer's open documents, not the whole
	 * manufacturer catalog, so the dropdown stays short. Documents are tagged, not split:
	 * a mixed-brand invoice shows in full under every brand on it.
	 */
	brandFilterEnabled = false;
	brandOptions: { id: number; name: string }[] = [];
	brand_selected: any[] = [];
	private invoiceSearchTerm = '';
	holdreasons: any = [];
	openjournals: any = [];
	selectedJournal: any = false;
	journalaction = false;
	allopenjournals: any = [];

	loadingjournal: any = false;

	jounral_sub: any = false;
	config: any = false;
	tags: any[] = [];
	paymentEntryNotes: any[] = [];
	salespeople: any[] = [];

	constructor(public dialog: MatDialog, private printService: PrintService, private modalService: NgbModal, public sanitizer: DomSanitizer, private ordersService: OrdersService, private globalSearchService: GlobalSearchService, private globalsService: GlobalsService, private paymentsService: PaymentsService, private fb: UntypedFormBuilder, private customerService: CustomerService, private route: ActivatedRoute, public router: Router, private generalLedgerService: GeneralLedgerService, private vendorService: VendorService, private documentIntakeService: DocumentIntakeService) {

		this.color = this.globalSearchService.getColor();
		this.globalSearchService.holdreasons.subscribe(r => {
			this.holdreasons = r;
		});

		// Live settlement-ref duplicate lookup. switchMap so a slow answer for an older
		// keystroke can never overwrite the verdict for what's in the field now.
		this.naRefCheckSub = this.naRefCheck$.pipe(
			debounceTime(350),
			switchMap((q: any) => this.vendorService.checkCreditReference(q.vendor, q.reference))
		).subscribe((res: any) => {
			this.naDupChecking = false;
			const asked = this.naRefCheckFor;
			const vendorNow = String(this.paymentForm?.get('na_vendor_id')?.value || '').trim();
			const refNow = String(this.paymentForm?.get('na_vendor_reference')?.value || '').trim();
			if (!asked || asked.vendor !== vendorNow || asked.reference !== refNow) { return; }
			this.applyNaDupResult(res);
		});

		this.globalSearchService.configsubscription.subscribe(s => {
			this.config = s;
			this.brandFilterEnabled = !!s?.arBrandFilter;
			const sp = this.cardForm?.get('savetoprofile');
			if (sp) {
				sp.setValue(this.globalSearchService.getSaveToProfileDefault());
			}
			if (this.paymentForm && this.naEnabled) {
				this.applyNaConfigGlDefaults();
			}
		})

	}

	confirmPdfDialog() {
		this.dialog.open(this.confirmPdfRef);
	}

	pdfJournalClose() {

		if (this.journal_review.value.journal_no) {

			const input = false;

			this.sending = true;

			const named = '';

			const encoded: string = this.globalSearchService.base64encode(this.journal_detailsRef.nativeElement.innerHTML);
			const data = {
				content: encoded,
				filename: 'journal_' + this.journal_review.value.journal_no,
			}

			this.printService.pdf(data).subscribe((result: any) => {
				this.globalSearchService.downloadPdf(result.content, data.filename);
				this.sending = false;
				const inputdata = {
					journal: this.journal_review.value
				}

				this.paymentsService.closeJournal(inputdata).subscribe((r: any) => {
					this.openjournals = r;
					this.journalaction = false;

					if (r.length) {
						this.paymentForm.get('journalno').setValue(r[0]);
					} else {
						this.paymentForm.get('journalno').setValue('');
					}

					this.getAllUserCurrentOpenJounrals();

				});
			});

		} else {
			alert('No Journal Selected');
		}
	}

	pdfJournal() {

		if (this.journal_review.value.journal_no) {
			this.sending = true;
			let named = '';
			if (this.journal_review.value.desc1) {
				named = ' ' + this.journal_review.value.journal_no + ' ' + this.journal_review.value.desc1;
			}

			const encoded: string = this.globalSearchService.base64encode(this.journal_detailsRef.nativeElement.innerHTML);
			const data = {
				content: encoded,
				filename: 'journal',
			}

			this.printService.pdf(data).subscribe((result: any) => {
				this.globalSearchService.downloadPdf(result.content, data.filename);
				this.sending = false;
			});
		} else {
			alert('No Journal Selected');
		}
	}

	xlsJournal() {
		this.sending = true;

		const encoded: string = this.globalSearchService.base64encode(this.journal_detailsRef.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: 'journal',
		}

		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.sending = false;
		});
	}

	ngOnInit(): void {

		this.globalSearchService.mesagesallowed.next(false);

		this.globalsService.getGLAccounts().subscribe((rows: any[]) => {
			const list = Array.isArray(rows) ? rows : [];
			this.naAllGlAccounts = list;
			this.naGlResults = this.naSliceGlPanel(list);
			this.naCommGlResults = this.naSliceGlPanel(list);
			this.glOverrideResults = this.naSliceGlPanel(list);
			if (this.naEnabled) {
				this.applyNaConfigGlDefaults();
			}
		});

		this.paymentForm = this.fb.group({
			debtorno: ['', Validators.required],
			branchcode: ['', Validators.required],
			payment_type: ['', Validators.required],
			bankaccount: ['', Validators.required],
			datepaid: [this.today, Validators.required],
			checkno: [''],
			reference: [''],
			description: [''],
			amount: [0.00, Validators.required],
			discount: [0, Validators.required],
			currency: ['', Validators.required],
			journalno: [''],
			tag: [null],
			searchString: [''],
			process_transaction: [false],
			charge_card: [],
			trigger_refund: [false],
			// Optional entry-time posting GL override — blank keeps the method/bank default.
			gl_account_override: [''],
			gl_override_name: [''],
			gl_override_search: [''],
			// Vendor-backed settlement — operator-toggled, available on any payment.
			// Relief / commission GL preload from config.nationalAccount when present.
			// Fields reset on submit, customer change, and toggle-off (no stored values).
			na_enabled: [false],
			na_vendor_id: [''],
			na_vendor_name: [''],
			na_vendor_search: [''],
			na_gl_account: [''],
			na_gl_name: [''],
			na_gl_search: [''],
			na_credit_amount: [0],
			na_commission_amount: [0],
			na_commission_gl: [''],
			na_commission_gl_name: [''],
			na_comm_gl_search: [''],
			na_vendor_reference: [''],
			na_invoice_date: [null],
			na_due_date: [null],
		});

		this.paymentForm.get('na_invoice_date')?.valueChanges.pipe(
			debounceTime(200),
			switchMap((d: Date) => {
				if (!d || !this.naSelectedVendor) { return of(null); }
				return this.vendorService.computeDueDate({
					invoiceDate: d instanceof Date ? d.toISOString() : String(d),
					daysbeforedue: parseInt(this.naSelectedVendor?.daysbeforedue) || 0,
					dayinfollowingmonth: parseInt(this.naSelectedVendor?.dayinfollowingmonth) || 0,
					statementperiods: parseInt(this.naSelectedVendor?.statementperiods) || 0,
				});
			})
		).subscribe((result: any) => {
			if (result?.duedate) {
				this.paymentForm.get('na_due_date')?.setValue(new Date(result.duedate), { emitEvent: false });
			}
		});

		this.paymentForm.get('datepaid')?.valueChanges.subscribe((d: any) => {
			if (!this.naEnabled) { return; }
			const invoiceDate = this.coerceFormDate(d);
			if (invoiceDate) {
				this.paymentForm.get('na_invoice_date')?.setValue(invoiceDate, { emitEvent: true });
			}
		});

		// Relief is what the vendor funds; commission is the slice of relief booked
		// above the customer invoice. Editing one derives the other so the AR receipt
		// (relief − commission) always settles to the selected invoice total.
		this.paymentForm.get('na_credit_amount')?.valueChanges
			.pipe(debounceTime(100))
			.subscribe(() => {
				if (this.naEnabled) {
					this.naReliefManual = true;
					this.naCommissionManual = false;
					this.deriveCommissionFromRelief();
				}
				this.syncNaPaymentAmount();
			});
		this.paymentForm.get('na_commission_amount')?.valueChanges
			.pipe(debounceTime(100))
			.subscribe(() => {
				if (this.naEnabled) {
					this.naCommissionManual = true;
					this.naReliefManual = false;
					this.naCommissionManual = false;
					this.deriveReliefFromCommission();
				}
				this.syncNaPaymentAmount();
			});

		this.bindNaEnabledChanges();

		combineLatest([
			this.globalSearchService.bankaccounts,
			this.globalSearchService.company
		]).pipe(
			filter(([accounts]) => Array.isArray(accounts) && accounts.length > 0)
		).subscribe(([accounts, company]) => {
			this.bankaccounts = accounts;
			this.paymentForm.get('bankaccount').setValue(
				resolveDefaultBankAccountCode(accounts, company?.defaultBankAccount)
			);
		});

		this.globalSearchService.currencies.subscribe((currencies: any) => {
			this.currencies = currencies
			if (currencies) {
				this.globalSearchService.company.subscribe((company: any) => {
					if (company) {
						this.paymentForm.get('currency').setValue(company.currencydefault);
					}
				});
			}
		});

		this.globalSearchService.payment_methods.subscribe((payment_methods: any) => {
			this.payment_methods = payment_methods
			if (payment_methods) {
				//this.updatePaymentType(payment_methods[0].paymentid);
			}
		});

		this.paymentsService.getPayments(this.today.toISOString()).subscribe((results: any) => {
			this.day_payments = results;
		});

		// Toggling "Select Invoices To Pay" re-arms the auto-seed of the amount.
		this.selectInvoiceToPay.valueChanges.subscribe(() => {
			this.amountManual = false;
		});

		this.selectAllPayments.valueChanges.subscribe((checked) => {
			this.customer.payments.forEach((payment) => {
				payment.selected = checked;
			});
		});

		this.selectAllInvoices.valueChanges.subscribe((checked) => {
			this.customer.transactions.forEach((transaction) => {
				transaction.selected = checked;
			});
		});

		this.generalLedgerService.getTags().subscribe((r: any) => {
			this.tags = r.tags || [];
		});
	}
	getSalesmanDisplay(): string {
		if (!this.customer?.salesman) return '';
		const sp = (this.salespeople || []).find((s: any) => String(s.salesmancode) === String(this.customer.salesman));
		return sp ? `${this.customer.salesman} - ${sp.salesmanname}` : String(this.customer.salesman);
	}

	getPaymentTypeName() {
		let name = '';
		if (this.paymentForm.get('payment_type').value != '' && this.paymentForm.get('payment_type').value) {
			if (this.payment_methods) {
				name = this.payment_methods.filter(p => {
					return p.paymentid == this.paymentForm.get('payment_type').value;
				})[0].paymentname;
			}
		}
		return name;
	}

	/** The full row for the currently-selected payment method (or null). */
	get selectedPaymentMethod(): any {
		const pid = this.paymentForm?.get('payment_type')?.value;
		if (!pid || !this.payment_methods) { return null; }
		return this.payment_methods.find((p: any) => p.paymentid == pid) || null;
	}

	/** Operator-toggled vendor-backed flow. Available on any payment method. */
	get naEnabled(): boolean {
		return !!this.paymentForm?.get('na_enabled')?.value;
	}

	private bindNaEnabledChanges(): void {
		if (this.naEnabledSub) {
			this.naEnabledSub.unsubscribe();
		}
		this.naEnabledSub = this.paymentForm.get('na_enabled')?.valueChanges.subscribe(on => {
			const vendor = this.paymentForm.get('na_vendor_id');
			const gl = this.paymentForm.get('na_gl_account');
			const amt = this.paymentForm.get('na_credit_amount');
			const invoiceDate = this.paymentForm.get('na_invoice_date');
			if (on) {
				this.selectInvoiceBeforeNa = this.selectInvoiceToPay.value;
				this.selectInvoiceToPay.setValue(true, { emitEvent: false });
				this.naReliefManual = false;
				this.naCommissionManual = false;
				this.syncNaPaymentAmount();
				this.filterReliefGl('');
				this.filterCommGl('');
				this.applyNaConfigGlDefaults();
				vendor?.setValidators([Validators.required]);
				gl?.setValidators([Validators.required]);
				// Negative relief is legitimate (payout / customer refund via vendor),
				// so only require a value; the addPayment guard blocks zero.
				amt?.setValidators([Validators.required]);
				invoiceDate?.setValidators([Validators.required]);
				this.prepopulateNaInvoiceDates(this.naSelectedVendor);
				const supplierid = this.paymentForm.get('na_vendor_id')?.value;
				if (supplierid && !this.naSelectedVendor) {
					this.loadNaVendorTerms(supplierid);
				}
			} else {
				this.selectInvoiceToPay.setValue(this.selectInvoiceBeforeNa, { emitEvent: false });
				this.naReliefManual = false;
				this.naCommissionManual = false;
				this.resetNaSettlementFields(false);
				vendor?.clearValidators();
				gl?.clearValidators();
				amt?.clearValidators();
				invoiceDate?.clearValidators();
			}
			vendor?.updateValueAndValidity({ emitEvent: false });
			gl?.updateValueAndValidity({ emitEvent: false });
			amt?.updateValueAndValidity({ emitEvent: false });
			invoiceDate?.updateValueAndValidity({ emitEvent: false });
		});
	}

	/** Preload relief / commission GL from client config (e.g. Cleve Hill 2000-0 / 7051-0). */
	private applyNaConfigGlDefaults(): void {
		const naCfg = this.config?.nationalAccount;
		if (!naCfg || !this.naEnabled) { return; }

		const reliefCode = String(naCfg.reliefGl || '').trim();
		if (reliefCode && !this.paymentForm.get('na_gl_account')?.value) {
			const acct = (this.naAllGlAccounts || []).find((a: any) =>
				String(a.accountcode || '').trim() === reliefCode
			);
			if (acct) {
				this.onNaGlPicked(acct);
			} else {
				this.paymentForm.patchValue({
					na_gl_account: reliefCode,
					na_gl_search: reliefCode,
				}, { emitEvent: false });
			}
		}

		const commCode = String(naCfg.commissionGl || '').trim();
		if (commCode && !this.paymentForm.get('na_commission_gl')?.value) {
			const acct = (this.naAllGlAccounts || []).find((a: any) =>
				String(a.accountcode || '').trim() === commCode
			);
			if (acct) {
				this.onNaCommGlPicked(acct);
			} else {
				this.paymentForm.patchValue({
					na_commission_gl: commCode,
					na_comm_gl_search: commCode,
				}, { emitEvent: false });
			}
		}
	}

	/** Clear vendor-backed fields — never persist across submit, customer change, or toggle-off. */
	resetNaSettlementFields(reapplyDefaults = false): void {
		this.naSelectedVendor = null;
		this.naMemoStatedComm = null;
		this.naDispensarySummary = null;
		this.naReliefManual = false;
		this.naCommissionManual = false;
		this.naForceInvoiceDate = null;
		this.paymentForm.patchValue({
			na_vendor_id: '', na_vendor_name: '', na_vendor_search: '',
			na_gl_account: '', na_gl_name: '', na_gl_search: '',
			na_credit_amount: 0,
			na_commission_amount: 0,
			na_commission_gl: '', na_commission_gl_name: '', na_comm_gl_search: '',
			na_vendor_reference: '',
			na_invoice_date: null,
			na_due_date: null,
		}, { emitEvent: false });
		this.naVendorResults = [];
		this.clearNaDup();
		this.naGlResults = this.naSliceGlPanel(this.naAllGlAccounts || []);
		this.naCommGlResults = this.naSliceGlPanel(this.naAllGlAccounts || []);
		if (reapplyDefaults && this.naEnabled) {
			this.applyNaConfigGlDefaults();
			this.prepopulateNaInvoiceDates();
		}
	}

	clearNaPanel(): void {
		this.resetNaSettlementFields(true);
		this.syncNaPaymentAmount();
	}

	// ── AI credit-memo intake ───────────────────────────────────────────────
	naUploading = false;
	/** Operator-facing flags raised when the AI couldn't confidently fill something. */
	naExtractWarnings: string[] = [];
	/** The COMMISSION line the AI read off the memo, kept so the panel can flag when the
	 *  spread it derives against the selected AR doesn't match what the vendor printed.
	 *  A gap means the customer credit isn't the mirror of the vendor's product credit —
	 *  the entry still balances, but somebody should look at which one is wrong. */
	naMemoStatedComm: number | null = null;
	/** One-shot: AI-extracted invoice date, consumed by prepopulateNaInvoiceDates so the
	 *  async vendor-terms callback doesn't overwrite it with the default. */
	private naForceInvoiceDate: Date | null = null;

	/** Drop/select handler for the "Upload credit memo (AI)" zone in the NA section. */
	async onCreditMemoSelected(files: File[] | FileList | null): Promise<void> {
		const file = files && (files as any)[0] ? (files as any)[0] as File : null;
		if (!file) { return; }
		if (!/\.pdf$/i.test(file.name) && file.type !== 'application/pdf') {
			this.globalSearchService.showNotification('Please drop a PDF credit memo', 'warning', 'bottom', 'left');
			return;
		}
		this.naUploading = true;
		this.naExtractWarnings = [];
		try {
			const mode = await this.resolveGroupMode(file);
			if (!mode) { this.naUploading = false; return; }
			const b64 = await this.documentIntakeService.fileToBase64(file);
			this.documentIntakeService.extractCreditMemo(b64, mode).subscribe(
				(res) => {
					this.naUploading = false;
					if (!res?.success || !res.memos?.length) {
						this.globalSearchService.showNotification(res?.message || 'Could not read this PDF', 'danger', 'bottom', 'left');
						return;
					}
					if (res.memos.length > 1) {
						// Multiple memos in one file belong in the batch queue, not this single form.
						this.globalSearchService.showNotification(
							`${res.memos.length} memos found — use the Vendor Intake batch screen to process them.`,
							'info', 'bottom', 'left'
						);
					}
					this.applyExtractedMemo(res.memos[0]);
				},
				() => {
					this.naUploading = false;
					this.globalSearchService.showNotification('Extraction failed — server error', 'danger', 'bottom', 'left');
				}
			);
		} catch {
			this.naUploading = false;
			this.globalSearchService.showNotification('Could not read the PDF file', 'danger', 'bottom', 'left');
		}
	}

	/** Decide single vs split: remembered preference, else ask only for multi-page PDFs. */
	private async resolveGroupMode(file: File): Promise<GroupMode | null> {
		const remembered = this.documentIntakeService.getSplitPref();
		if (remembered) { return remembered; }
		const pages = await this.documentIntakeService.getPdfPageCount(file);
		if (pages <= 1) { return 'single'; }
		const ref = this.dialog.open(MultipagePromptComponent, {
			width: '480px',
			data: { fileName: file.name, pageCount: pages },
		});
		const result = await ref.afterClosed().toPromise() as MultipagePromptResult | null;
		if (!result) { return null; }
		if (result.remember) { this.documentIntakeService.setSplitPref(result.mode); }
		return result.mode;
	}

	/**
	 * Pre-fill the NA form from an extracted memo. AI fills — the operator reviews and posts.
	 * Low-confidence vendor/customer matches are left unselected and surfaced as warnings,
	 * never silently applied.
	 */
	applyExtractedMemo(memo: ExtractedMemo): void {
		if (!memo?.fields) { return; }
		const f = memo.fields;
		this.naExtractWarnings = [];

		if (f.document_type === 'other') {
			this.globalSearchService.showNotification('This PDF does not look like a credit memo — review before posting', 'warning', 'bottom', 'left');
		}

		// A DEBIT memo is the mirror of a credit memo: the vendor is billing the money
		// BACK (a returned/reversed deal), so relief is negative — we owe them. The
		// extractor reports every amount positive by design, so the sign is applied
		// here; keying it positive posted the settlement backwards.
		const isDebitMemo = f.document_type === 'debit_memo';
		const sign = isDebitMemo ? -1 : 1;
		if (isDebitMemo) {
			this.naExtractWarnings.push(
				'DEBIT memo — the vendor is billing this back, so relief is negative. ' +
				'Select the customer credit it settles against on the left.'
			);
		}

		const invDate = this.coerceFormDate(f.invoice_date);

		// Turn on the vendor-backed flow (preloads relief/commission GL defaults from config).
		// The enable handler synchronously prepopulates invoice date, so arm the one-shot
		// AFTER enabling — it must survive until the async vendor-terms callback.
		if (!this.naEnabled) {
			this.paymentForm.get('na_enabled')?.setValue(true);
		}
		this.naForceInvoiceDate = invDate;

		// Vendor: only auto-select a confident match; otherwise flag for the operator to pick.
		const vm = memo.vendor_match;
		if (vm && vm.auto && vm.supplierid) {
			this.onNaVendorPicked({ supplierid: vm.supplierid, suppname: vm.suppname });
		} else {
			this.paymentForm.get('na_vendor_search')?.setValue(f.vendor_name || '', { emitEvent: false });
			this.naExtractWarnings.push(
				vm ? `Vendor "${f.vendor_name}" → closest match "${vm.suppname}" (low confidence) — confirm the vendor`
				   : `Vendor "${f.vendor_name}" not matched — pick the backing vendor`
			);
		}

		// Customer is fixed to this payment page; warn if the memo names a different one.
		const cm = memo.customer_match;
		const currentDebtor = String(this.paymentForm.get('debtorno')?.value || '');
		if (cm && currentDebtor && String(cm.debtorno) !== currentDebtor) {
			this.naExtractWarnings.push(
				`Memo customer "${f.customer_name}"${f.customer_account ? ' (' + f.customer_account + ')' : ''} differs from the open customer — verify you're on the right account`
			);
		}

		// Amounts: set relief + commission explicitly (emitEvent:false so the derive
		// subscribers don't clobber the AI commission). Hold commission fixed so later
		// invoice selection recomputes relief to settle the chosen invoice.
		const total = this.financial(sign * (Number(f.total_amount) || 0));
		const commission = this.financial(sign * (Number(f.commission_amount) || 0));
		this.naMemoStatedComm = Math.abs(commission) > 0.004 ? commission : null;
		this.paymentForm.get('na_credit_amount')?.setValue(total, { emitEvent: false });
		this.paymentForm.get('na_commission_amount')?.setValue(commission, { emitEvent: false });
		// On a debit memo the DOCUMENT total is the hard fact — it has to tie to the vendor
		// statement — while the AR it settles is whatever credit is open. So pin the relief
		// and let the spread plug the difference. (Credit memos keep the old behaviour:
		// docintake picks the invoice that matches relief − commission, so holding the
		// commission fixed there re-derives relief to settle that invoice to the cent.)
		this.naReliefManual = isDebitMemo;
		this.naCommissionManual = !isDebitMemo && Math.abs(commission) > 0.004;
		this.syncNaPaymentAmount();

		// Dates + reference. (na_invoice_date is also asserted here for the no-vendor-match
		// path, where the vendor-terms callback never runs.)
		if (invDate) { this.paymentForm.get('na_invoice_date')?.setValue(invDate, { emitEvent: false }); }
		const due = this.coerceFormDate(f.due_date);
		if (due) { this.paymentForm.get('na_due_date')?.setValue(due, { emitEvent: false }); }
		const ref = f.credit_memo_number || f.source_invoice_ref || f.po_number || '';
		if (ref) {
			this.paymentForm.get('na_vendor_reference')?.setValue(ref, { emitEvent: false });
			// An AI-filled memo # is the likeliest duplicate of all — check it without waiting
			// for the operator to touch the field.
			this.queueNaRefCheck();
		}

		if (Math.abs(commission) > 0.004 && !String(this.paymentForm.get('na_commission_gl')?.value || '').trim()) {
			this.naExtractWarnings.push('Commission found — confirm the commission GL account');
		}

		this.globalSearchService.showNotification(
			`${isDebitMemo ? 'Debit' : 'Credit'} memo read: ${f.vendor_name || 'vendor'} · relief ${total.toFixed(2)}` +
			(Math.abs(commission) > 0.004 ? ` · ${commission < 0 ? 'loss' : 'commission'} ${commission.toFixed(2)}` : ''),
			'success', 'bottom', 'left'
		);
	}

	/** Pick up a memo handed off from the batch screen (set via DocumentIntakeService.stashMemo). */
	private consumePendingMemo(): void {
		const memo = this.documentIntakeService.takeMemo();
		if (memo) {
			// Defer so customer/GL data has a tick to populate before we map onto the form.
			setTimeout(() => this.applyExtractedMemo(memo), 0);
		}
	}

	/** Signed AR amount this settlement has to land on: selected invoices (debits,
	 *  positive) net of selected payments / credit memos (credits, negative).
	 *  A straight settlement is just the invoice total. A claw-back has no invoice —
	 *  the operator selects the customer's open credit instead — so the target goes
	 *  NEGATIVE. Every relief/spread derive works off this, not off the invoice total:
	 *  keying only off invoices left the credit case with a target of 0, which silently
	 *  short-circuited every derive and left the spread stuck at zero. */
	private naArTarget(): number {
		const credits = (this.allocations_from || []).reduce((acc: number, item: any) => {
			const v = parseFloat(item.allocation);
			return acc + (isNaN(v) ? 0 : v);
		}, 0);
		return this.financial(this.allocation_to_total + credits);
	}

	/** True once the operator has selected enough AR (either side) to settle against. */
	private naHasArTarget(): boolean {
		return Math.abs(this.naArTarget()) > 0.005;
	}

	/** Copy the selected AR — invoices net of credits — into vendor relief $. */
	applySelectedInvoicesToNaRelief(): void {
		if (!this.naHasArTarget()) {
			this.globalSearchService.showNotification(
				'Select customer invoices or credits first',
				'danger', 'bottom', 'left'
			);
			return;
		}
		this.paymentForm.get('na_credit_amount')?.setValue(this.naArTarget());
	}

	/** Bottom-bar payment stat: NA mode shows customer AR relief, not vendor payment pool. */
	bottomBarPaymentAmount(): number {
		if (this.naEnabled) {
			return this.naArTarget();
		}
		const from = this.financial(this.allocation_from_total);
		return from ? from * -1 : 0;
	}

	bottomBarPaymentLabel(): string {
		return this.naEnabled ? 'AR Relief' : 'Payment';
	}

	/** AR receipt = vendor relief minus the spread, so it settles to the customer
	 *  invoice total. The spread is the relief booked above the invoice: positive is
	 *  commission (house income), negative is a loss (the vendor funded less than we
	 *  billed). Either way relief − spread lands on the invoice total. */
	private syncNaPaymentAmount(): void {
		if (!this.naEnabled) { return; }
		const credit = parseFloat(this.paymentForm.get('na_credit_amount')?.value || 0) || 0;
		const commission = parseFloat(this.paymentForm.get('na_commission_amount')?.value || 0) || 0;
		const total = Math.round((credit - commission) * 100) / 100;
		if (total !== 0) {
			this.paymentForm.get('amount')?.setValue(total, { emitEvent: true });
		}
	}

	/** Auto-fill relief and commission from the selected AR when NA is active.
	 *  Commission is the relief booked above the target (relief − target); whichever
	 *  field the operator last touched is held fixed and the other is recomputed.
	 *  Sign-agnostic — the target is negative on a claw-back against a credit. */
	private syncNaFromSelection(): void {
		if (!this.naHasArTarget()) { return; }
		const arTarget = this.naArTarget();

		const currentRelief = this.financial(
			parseFloat(this.paymentForm.get('na_credit_amount')?.value || 0) || 0
		);

		if (this.naCommissionManual) {
			// Operator typed the commission — relief is the remainder.
			this.deriveReliefFromCommission(arTarget);
		} else if (this.naReliefManual && Math.abs(currentRelief) > 0.005) {
			// Operator typed the relief — commission is the remainder.
			this.deriveCommissionFromRelief(arTarget);
		} else {
			// Untouched — full relief, no commission.
			this.paymentForm.get('na_credit_amount')?.setValue(arTarget, { emitEvent: false });
			this.paymentForm.get('na_commission_amount')?.setValue(0, { emitEvent: false });
		}

		this.syncNaPaymentAmount();
	}

	/** Signed gap between the spread this settlement derives and the COMMISSION line the
	 *  vendor printed, or null when they agree (or no memo was read). Surfaced under the
	 *  Comm / Loss field — the posting still balances either way, so it's a flag, not a block. */
	naMemoCommGap(): number | null {
		if (this.naMemoStatedComm === null) { return null; }
		const comm = this.financial(parseFloat(this.paymentForm.get('na_commission_amount')?.value || 0) || 0);
		const gap = this.financial(comm - this.naMemoStatedComm);
		return Math.abs(gap) > 0.01 ? gap : null;
	}

	/** spread = relief − AR target. Signed: positive is commission earned above the
	 *  target, negative is a loss the vendor did not fund. NOT clamped — clamping at 0
	 *  dropped the loss silently and left the invoice short by that amount. Guard is on
	 *  the MAGNITUDE so a claw-back (negative target) still derives. */
	private deriveCommissionFromRelief(arTarget?: number): void {
		const total = arTarget ?? this.naArTarget();
		if (Math.abs(total) <= 0.005) { return; }
		const relief = this.financial(parseFloat(this.paymentForm.get('na_credit_amount')?.value || 0) || 0);
		const comm = this.financial(relief - total);
		this.paymentForm.get('na_commission_amount')?.setValue(comm, { emitEvent: false });
	}

	/** relief = AR target + spread (signed — a negative spread means the vendor funds
	 *  less than the target). */
	private deriveReliefFromCommission(arTarget?: number): void {
		const total = arTarget ?? this.naArTarget();
		if (Math.abs(total) <= 0.005) { return; }
		const comm = this.financial(parseFloat(this.paymentForm.get('na_commission_amount')?.value || 0) || 0);
		const relief = this.financial(total + comm);
		this.paymentForm.get('na_credit_amount')?.setValue(relief, { emitEvent: false });
	}

	filterReliefGl(term: string): void {
		const q = (term || '').trim().toLowerCase();
		const source = this.naAllGlAccounts || [];
		this.naGlResults = this.naSliceGlPanel(
			q ? source.filter((a: any) =>
				String(a.accountcode || '').toLowerCase().includes(q) ||
				String(a.accountname || '').toLowerCase().includes(q)
			) : source
		);
	}

	filterCommGl(term: string): void {
		const q = (term || '').trim().toLowerCase();
		const source = this.naAllGlAccounts || [];
		this.naCommGlResults = this.naSliceGlPanel(
			q ? source.filter((a: any) =>
				String(a.accountcode || '').toLowerCase().includes(q) ||
				String(a.accountname || '').toLowerCase().includes(q)
			) : source
		);
	}

	naSearch(keywords: string) {
		const term = (keywords || '').trim();
		if (this.naVendorSearchSub) { this.naVendorSearchSub.unsubscribe?.(); }
		if (term.length < 2) {
			this.naVendorResults = [];
			return;
		}
		this.naVendorSearchSub = this.vendorService.getVendorSearch(term).subscribe((r: any) => {
			// vendor/search may return: array, {rows: []}, {data: []}, or {success, vendors: []}
			let rows: any[] = [];
			if (Array.isArray(r)) { rows = r; }
			else if (Array.isArray(r?.rows)) { rows = r.rows; }
			else if (Array.isArray(r?.data)) { rows = r.data; }
			else if (Array.isArray(r?.vendors)) { rows = r.vendors; }
			else if (Array.isArray(r?.suppliers)) { rows = r.suppliers; }
			this.naVendorResults = rows.slice(0, 50);
		});
	}

	/** Picked from the autocomplete option list. Mirrors the customer-search pattern
	 *  on this page: assign the id + name to hidden fields, then set the input to
	 *  the display name. No [displayWith] — that fights live typing. */
	onNaVendorPicked(vendor: any) {
		if (!vendor) { return; }
		const id = vendor.supplierid || vendor.supplier_id || vendor.id || '';
		const name = vendor.suppname || vendor.name || vendor.supplier_name || String(id);
		this.paymentForm.get('na_vendor_id').setValue(id);
		this.paymentForm.get('na_vendor_name').setValue(name);
		this.paymentForm.get('na_vendor_search').setValue(name, { emitEvent: false });
		this.loadDispensarySummary();
		this.loadNaVendorTerms(id);
		// A reference is only a duplicate against a given vendor — re-check on vendor change.
		this.queueNaRefCheck();
	}

	/** Operator is typing the settlement ref — drop the previous verdict (it belonged to the
	 *  reference that was there before this keystroke) and queue a debounced re-check. */
	onNaReferenceTyped(): void {
		this.clearNaDup();
		this.queueNaRefCheck();
	}

	/** Fire a duplicate lookup for whatever vendor + reference the panel currently holds. */
	private queueNaRefCheck(): void {
		const vendorid = String(this.paymentForm?.get('na_vendor_id')?.value || '').trim();
		const reference = String(this.paymentForm?.get('na_vendor_reference')?.value || '').trim();
		if (!this.naEnabled || !vendorid || !reference) {
			this.naDupChecking = false;
			return;
		}
		this.naDupChecking = true;
		this.naRefCheckFor = { vendor: vendorid, reference };
		this.naRefCheck$.next({ vendor: vendorid, reference });
	}

	/** Flag the field (and block Pay) when the reference is already on a live vendor credit. */
	private applyNaDupResult(res: any): void {
		const control = this.paymentForm?.get('na_vendor_reference');
		if (res && res.used) {
			this.naDupCredit = {
				transno: res.transno || '',
				amount: Number(res.amount) || 0,
				trandate: res.trandate || '',
				reference: res.reference || '',
			};
			control?.setErrors({ ...(control.errors || {}), referenceUsed: true });
			// Material's default error matcher only paints an error once the control is
			// touched — typing alone leaves it untouched, so the message would stay hidden
			// until blur, which is exactly what this check exists to avoid.
			control?.markAsTouched();
			return;
		}
		this.naDupCredit = null;
		this.stripNaDupError();
	}

	/** Clear the duplicate verdict + its validation error. Must run whenever the panel is
	 *  reset or toggled off — a stale referenceUsed error would dead-lock the Pay button. */
	private clearNaDup(): void {
		this.naDupCredit = null;
		this.naDupChecking = false;
		this.naRefCheckFor = null;
		this.stripNaDupError();
	}

	private stripNaDupError(): void {
		const control = this.paymentForm?.get('na_vendor_reference');
		const errs = control?.errors;
		if (errs?.referenceUsed) {
			const next = { ...errs };
			delete next.referenceUsed;
			control.setErrors(Object.keys(next).length ? next : null);
		}
	}

	/** Field-level message. Deliberately just the verdict — the field is small and the
	 *  operator only needs to know the reference is taken. */
	get naDupMessage(): string {
		return this.naDupCredit ? 'Already booked' : '';
	}

	private coerceFormDate(value: any): Date | null {
		if (value instanceof Date && !isNaN(value.getTime())) { return value; }
		if (typeof value === 'string' && value.trim()) {
			const parsed = new Date(value);
			if (!isNaN(parsed.getTime())) { return parsed; }
		}
		return null;
	}

	private formatNaPostDate(value: any): string {
		const d = this.coerceFormDate(value);
		if (d) {
			return d.toISOString().slice(0, 10);
		}
		if (typeof value === 'string' && value.length >= 10) {
			return value.slice(0, 10);
		}
		return '';
	}

	private naDefaultInvoiceDate(): Date {
		return this.coerceFormDate(this.paymentForm?.get('datepaid')?.value) || this.today;
	}

	private prepopulateNaInvoiceDates(vendor?: any): void {
		// When AI pre-fill supplied an invoice date, honor it once instead of the default —
		// the async vendor-terms load must not clobber the extracted date.
		const forced = this.naForceInvoiceDate;
		this.naForceInvoiceDate = null;
		const invoiceDate = forced || this.naDefaultInvoiceDate();
		this.paymentForm.get('na_invoice_date')?.setValue(invoiceDate, { emitEvent: !!vendor });
	}

	private loadNaVendorTerms(supplierid: string): void {
		if (!supplierid) {
			this.naSelectedVendor = null;
			return;
		}
		this.vendorService.getVendor(supplierid).subscribe((vendor: any) => {
			this.naSelectedVendor = vendor;
			this.prepopulateNaInvoiceDates(vendor);
		});
	}

	loadDispensarySummary() {
		const supplierid = this.paymentForm.get('na_vendor_id')?.value;
		const debtorno = this.customer?.debtorno;
		this.naDispensarySummary = null;
		if (!supplierid || !debtorno) { return; }
		this.vendorService.getDispensaryOpenSummary(supplierid, debtorno).subscribe((r: any) => {
			if (r && r.open_rows > 0) {
				this.naDispensarySummary = r;
			}
		});
	}

	onNaGlPicked(account: any) {
		if (!account) { return; }
		const code = account.accountcode || '';
		const name = account.accountname || '';
		this.paymentForm.get('na_gl_account').setValue(code);
		this.paymentForm.get('na_gl_name').setValue(name);
		this.paymentForm.get('na_gl_search').setValue(`${code} — ${name}`, { emitEvent: false });
	}

	/** Full GL chart can be thousands of rows — Material autocomplete breaks if we bind them all. */
	private naSliceGlPanel(rows: any[]): any[] {
		return Array.isArray(rows) ? rows.slice(0, 100) : [];
	}

	onNaCommGlPicked(account: any) {
		if (!account) { return; }
		const code = account.accountcode || '';
		const name = account.accountname || '';
		this.paymentForm.get('na_commission_gl').setValue(code);
		this.paymentForm.get('na_commission_gl_name').setValue(name);
		this.paymentForm.get('na_comm_gl_search').setValue(`${code} — ${name}`, { emitEvent: false });
	}

	/** If the operator typed a GL code in the search field without clicking
	 *  an autocomplete option, try to resolve it against naAllGlAccounts.
	 *  Match logic: exact code match (case-insensitive), or "<code> — <name>"
	 *  shape match. Mutates the hidden code/name fields when a match is found. */
	private naResolveTypedGlPick(searchKey: string, codeKey: string, nameKey: string): void {
		const codeCtrl = this.paymentForm.get(codeKey);
		if (codeCtrl && codeCtrl.value) { return; }  // already picked, nothing to do
		const rawCtrl = this.paymentForm.get(searchKey);
		const raw = String(rawCtrl?.value || '').trim();
		if (!raw) { return; }
		// Strip " — name" suffix if present so a typed-then-edited value still resolves.
		const code = raw.split('—')[0].trim();
		if (!code) { return; }
		const match = (this.naAllGlAccounts || []).find((a: any) =>
			String(a.accountcode || '').toLowerCase() === code.toLowerCase()
		);
		if (match) {
			codeCtrl?.setValue(match.accountcode);
			this.paymentForm.get(nameKey)?.setValue(match.accountname);
			rawCtrl?.setValue(`${match.accountcode} — ${match.accountname}`, { emitEvent: false });
		}
	}

	/** Optional posting-GL override — reuses the full chart loaded for the NA panel. */
	filterOverrideGl(term: string): void {
		const q = (term || '').trim().toLowerCase();
		const source = this.naAllGlAccounts || [];
		this.glOverrideResults = this.naSliceGlPanel(
			q ? source.filter((a: any) =>
				String(a.accountcode || '').toLowerCase().includes(q) ||
				String(a.accountname || '').toLowerCase().includes(q)
			) : source
		);
	}

	onOverrideGlPicked(account: any) {
		if (!account) { return; }
		const code = account.accountcode || '';
		const name = account.accountname || '';
		this.paymentForm.get('gl_account_override').setValue(code);
		this.paymentForm.get('gl_override_name').setValue(name);
		this.paymentForm.get('gl_override_search').setValue(`${code} — ${name}`, { emitEvent: false });
	}

	clearGlOverride(event?: any) {
		if (event) { event.stopPropagation(); }
		this.paymentForm.get('gl_account_override').setValue('');
		this.paymentForm.get('gl_override_name').setValue('');
		this.paymentForm.get('gl_override_search').setValue('', { emitEvent: false });
		this.glOverrideResults = this.naSliceGlPanel(this.naAllGlAccounts || []);
	}

	getSelectedJournal(event: any) {
		this.selectedJournal = event.value;
		this.loadSelectedJournal();
	}

	loadSelectedJournal() {
		this.loadingjournal = true;
		if (this.jounral_sub) {
			this.jounral_sub.unsubscribe();
		}
		this.jounral_sub = this.paymentsService.getJournal(this.selectedJournal).subscribe(r => {
			this.loadingjournal = false;
			this.journal_payments = r;
		});
	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		// Math.round (half away from zero), NOT toFixed — toFixed on binary floats sends
		// .xx5 DOWN ((423.675).toFixed(2) === "423.67") while syncNaPaymentAmount() and the
		// server's number_format() both round halves UP. Three rounding rules in one flow
		// put relief, commission and the posted amount a penny apart on half-cent inputs
		// (XLSX remittance imports carry 3-decimal values). EPSILON absorbs float
		// representation error so 423.675 is not already 423.67499999 when it gets here.
		const n = Number.parseFloat(x);
		const sign = n < 0 ? -1 : 1;
		return sign * Math.round((Math.abs(n) + Number.EPSILON) * 100) / 100;
	}

	customerBalanceReduce() {

		if (this.paymentForm.get('amount').value) {
			return this.financial(this.customer.aged.balance) - this.financial(this.paymentForm.get('amount').value)
		}
		return this.financial(this.customer.aged.balance);
	}

	setExapanded(payment: any) {
		this.expandedElement = (this.expandedElement == payment) ? false : payment;
		if (!this.expandedElement) {
			//no running variable
			const data = { from: this.paymentForm.get('datepaid').value, to: this.paymentForm.get('datepaid').value }
			this.paymentsService.getPaymentRange(data).subscribe((results: any) => {
				this.payments = results;
			});
		}
	}
	updateHoldReason() {
		const data = {
			holdreason: this.holdReason.value,
			debtorno: this.customer.debtorno,
			//branchcode: this.customer.branchcode,
			//ediinvoices: this.customer.ediinvoices,
			//emailstatement: this.customer.emailstatement,
			//arintrate: this.customer.arintrate,
			//currcode: this.customer.currcode,
			//creditlimit: this.customer.creditlimit,
			//customerpoline: this.customer.customerpoline,
		}
		this.customerService.updateDebtor(data).subscribe(r => {

		})
	}

	getPaymentTypeJournal(method: any) {

		this.paymentsService.getJournals(method).subscribe((result: any) => {
			this.openjournals = result;
			//not firing in ogetOPenJounrls?
			this.getAllUserCurrentOpenJounrals();

			if (result.length) {
				this.paymentForm.get('journalno').setValue(result[0]);
			} else {
				this.paymentForm.get('journalno').setValue('');
			}
		});


	}

	getAllUserCurrentOpenJounrals() {
		const data = {};
		this.paymentsService.getAllUserOpenJounrals(data).subscribe((result: any) => {
			this.allopenjournals = result;
		});
	}

	getJournals() {

		const data = {
			type: this.getPaymentTypeName()
		};

		this.paymentsService.getJournals(data).subscribe((result: any) => {
			this.openjournals = result;
			this.getAllUserCurrentOpenJounrals();
			if (result.length) {
				this.paymentForm.get('journalno').setValue(result[0]);
			} else {
				this.paymentForm.get('journalno').setValue('');
			}
		});


	}

	closeJournal(event: any) {

		if (event) {
			event.stopPropagation();
			event.preventDefault();
		}

		const data = {
			journal: this.paymentForm.get('journalno').value
		};
		this.journalaction = true;
		this.paymentsService.closeJournal(data).subscribe((result: any) => {
			this.openjournals = result;
			this.journalaction = false;

			if (result.length) {
				this.paymentForm.get('journalno').setValue(result[0]);
			} else {
				this.paymentForm.get('journalno').setValue('');
			}

			this.getAllUserCurrentOpenJounrals();

		});
	}

	openNewJournal(event: any) {
		if (event) {
			event.stopPropagation();
			event.preventDefault();
		}

		const data = {};
		this.journalaction = true;
		this.paymentsService.openJournal(data).subscribe((result: any) => {
			this.journalaction = false;
			this.openjournals = result;
			if (result.length) {
				this.paymentForm.get('journalno').setValue(result[0]);
			} else {
				this.paymentForm.get('journalno').setValue('');
			}
			this.getAllUserCurrentOpenJounrals();
		});
	}

	loadCustomer() {

		this.paymentsService.getCustomerAccountReceivables(this.customer.debtorno, this.customer.branchcode, this.brandFilterEnabled).subscribe((results: any) => {
			this.customer = results;
			this.resetNaSettlementFields(this.naEnabled);

			this.allocations_from = [];
			this.allocations_to = [];
			this.allocation_from_total = 0.00;
			this.allocation_to_total = 0.00;
			this.holdReason.setValue(results.holdreason);
			this.searchString.setValue(results.name);

			if (this.config?.paymentEntryShowSalesmanAndCustomerNotes) {
				this.paymentEntryNotes = [];
				this.customerService.getCustomerNotes({ debtorno: results.debtorno, branchcode: results.branchcode }).subscribe((notes: any) => {
					this.paymentEntryNotes = Array.isArray(notes) ? notes : (notes?.notes || []);
				});
				if (!this.salespeople.length) {
					this.globalsService.getSalesPeople().subscribe((r: any) => {
						this.salespeople = r || [];
					});
				}
			} else {
				this.paymentEntryNotes = [];
			}

			this.loadProfile(results.debtorno, results.branchcode);

			this.customertransactions = results.transactions;
			this.allcredits = results.payments
			this.alldebits = results.transactions

			this.alltransactions = results.transactions;
			this.allpayments = results.payments;

			this.buildBrandOptions();
			this.applyInvoiceFilters();

			this.paymentForm.get('debtorno').setValue(results.debtorno);
			this.paymentForm.get('branchcode').setValue(results.branchcode);
			this.paymentForm.get('amount').valueChanges.subscribe(newValue => {
				this.updateTotals();
			})

			this.customerSearchInline.setValue(this.customer.name);
			this.paymentForm.get('payment_type').valueChanges.subscribe(newValue => {
				if (newValue) {
					const thispay = this.payment_methods.filter(p => {
						return p.paymentid == newValue
					})[0];

					if (thispay.refunds == '1' && thispay) {
						this.showrefunds = true;
					} else {
						this.showrefunds = false;
					}

					this.setCardRequired(newValue);
				}
			})

			this.setCardForm();

			const links = {
				debtorno: this.customer.debtorno,
				branchcode: this.customer.branchcode,
				transno: '',
			}

			this.paymentsService.getLinks(links).subscribe((result: any) => {
				this.thirdpartylinks = result
			});

			this.flip = 'inactive';

			this.loadPayments();

		});
	}

	toggleFlip() {
		this.flip = (this.flip == 'active') ? 'inactive' : 'active';

		switch (this.flip) {
		case 'active':
			this.loadSelectedJournal();
			setTimeout(() => {
				this.journal_review.updateValueAndValidity();
			});
			break;
		}
	}

	openModal(url) {

		//url = url + '&output=embed';
		/*
		this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(url+'&embed=true');
		this.modalService.open(this.thirdpartyRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
		});
		*/
	}

	voidPayment(pay: any) {
		this.paymentsService.voidPayment(pay).subscribe((result: any) => {
			if (result.success) {
				this.loadPayments();
			} else {
				alert(result.message)
			}
		})
	}

	loadPayments() {
		this.running = true;
		const data = { from: this.paymentForm.get('datepaid').value, to: this.paymentForm.get('datepaid').value }
		this.paymentsService.getPaymentRange(data).subscribe((results: any) => {
			this.running = false;
			this.payments = results;

			this.total_pay = results.summary.reduce(function(accumulator: number, items: any) {
				return accumulator + parseFloat(items.amount);
			}, 0);
		})
	}

	loadProfile(debtorno: any, branchcode: any) {

		this.paymentsService.loadProfile(debtorno, branchcode).subscribe(async (result: any) => {
			// NO SILENT CARD SELECT. Loading a profile is not an operator decision.
			// This used to pick the customer's default saved card, push its
			// payment_method through updatePaymentType() and arm 'existing_card' —
			// so the method the operator had chosen (Check) was silently replaced
			// by the card's method and the card on file was charged for real.
			// It also re-fired after every successful post (loadCustomer ->
			// loadProfile), which is how batch check entry ended up on plastic.
			// The picker still lists the cards; selection comes from the operator.
			if (result.cards) {
				this.hasprofile = true;
				this.profile_cards = result.cards
			} else {
				this.hasprofile = false;
				this.profile_cards = [];
			}

			this.payment_card = false;
			this.charge_card = false;
			this.selected_card.setValue(false);
			this.paymentForm.get('charge_card').setValue(false);
			if (!this.card_required) {
				this.chargecardtype = 'no_charge';
				this.paymentForm.get('process_transaction').setValue('no_charge');
			}
		});
	}

	setCardForm() {
		this.cardForm = this.fb.group({
			debtorno: [this.customer.debtorno, Validators.required],
			branchcode: [this.customer.branchcode, Validators.required],
			name: [this.customer.name, Validators.required],
			ccnumber: ['', Validators.required],
			expiry: ['', Validators.required],
			card_id: [true],
			cvv: ['', Validators.required],
			savetoprofile: [this.globalSearchService.getSaveToProfileDefault(), Validators.required]
		});


	}

	setCardRequired(method: any) {
		if (method) {
			const thispay = this.payment_methods.filter(p => {
				return p.paymentid == method
			})[0];

			if (thispay.cc_process !== '0') {
				this.card_required = true;
				this.paymentForm.get('trigger_refund').setValue(false);
				// Auto-select "Existing Card" if cards are available
				if (this.profile_cards && this.profile_cards.length > 0) {
					this.chargecardtype = 'existing_card';
					this.paymentForm.get('process_transaction').setValue('existing_card');
				}
			} else {
				this.card_required = false;
				this.selected_card.setValue(false);
				this.paymentForm.get('charge_card').setValue(false)
				this.paymentForm.get('trigger_refund').setValue(false);
				this.charge_card = false;
				this.chargecardtype = 'no_charge';
				// Disarm the charge switch too — clearing chargecardtype alone left
				// process_transaction on 'existing_card', which is what the server
				// actually reads to decide whether to hit the gateway.
				this.paymentForm.get('process_transaction').setValue('no_charge');
			}
		}
	}

	updatePaymentType(method: any) {
		this.paymentForm.get('payment_type').setValue(method);
		this.setCardRequired(method);

		const ptype = this.payment_methods.filter((type: any) => {
			return type.paymentid == method
		})[0];

		this.getPaymentTypeJournal(ptype);

		// Auto-open the vendor-backed (national account) panel when the selected
		// payment method is flagged as a national account type, and close it when not.
		if (ptype && Number(ptype.national_account) === 1) {
			if (!this.naEnabled) {
				this.resetNaSettlementFields(false);
				this.paymentForm.get('na_enabled')?.setValue(true);
			}
		} else if (ptype && Number(ptype.national_account) !== 1) {
			this.paymentForm.get('na_enabled')?.setValue(false);
		}
	}

	updateProfile(event: any) {
		this.customer.profile = event;
		this.addingcard = false;
		this.editingcard = false;
		this.sending = false;
		this.profile_cards = event.cards
		this.hasprofile = (event.cards.length) ? true : false;
		this.profile_cards = event.cards
	}

	toggleAddCard() {
		this.addingcard = (this.addingcard) ? false : true
	}

	/** Operator hand-edited the receipt amount — stop auto-seeding it from selected invoices. */
	onAmountEdited() {
		if (!this.naEnabled) { this.amountManual = true; }
	}

	updateTotals() {
		// Calculate the total allocation to
		this.allocation_to_total = this.allocations_to.reduce((accumulator: number, item: any) => {
			const allocation = parseFloat(item.allocation);
			return accumulator + (isNaN(allocation) ? 0 : allocation);
		}, 0);

		// Calculate the total allocation from
		const paymentAmount = parseFloat(this.paymentForm.get('amount').value) || 0;
		const discountAmount = parseFloat(this.paymentForm.get('discount').value) || 0;
		const fromAlloc = this.allocations_from.reduce((accumulator: number, item: any) => {
			const allocation = parseFloat(item.allocation);
			return accumulator + (isNaN(allocation) ? 0 : allocation);
		}, 0);

		// Vendor-backed: bottom bar tracks customer AR (invoices), not the receipt amount.
		this.allocation_from_total = this.naEnabled
			? fromAlloc + (-1 * discountAmount)
			: fromAlloc + (-1 * paymentAmount) + (-1 * discountAmount);

		// Seed the payment amount from the selected invoices, but never gate the
		// operator out of it — once they hand-edit the amount, leave it alone.
		if (this.selectInvoiceToPay.value && !this.naEnabled && !this.amountManual) {
			const amount = this.financial(this.allocation_to_total);
			this.paymentForm.get('amount').setValue(amount, { emitEvent: false });
		}

		if (this.naEnabled && this.selectInvoiceToPay.value) {
			this.syncNaFromSelection();
		}
	}


	//update allocations
	updateAllocationTo(input, pay) {
		const index = this.allocations_to.indexOf(pay);
		if (index >= 0) {
			this.allocations_to[index].allocation = input;
			if (parseFloat(input) > this.allocations_to[index].leftto) {
				this.allocations_to[index].allocation = parseFloat(this.allocations_to[index].leftto);
			}
		}
		this.updateTotals();
	}

	//update alloc from
	updateAllocationFrom(input, pay) {


		const index = this.allocations_from.indexOf(pay);
		if (index >= 0) {
			if (parseFloat(input) > parseFloat(this.allocations_from[index].leftto)) {
				//this.allocations_from[index].allocation = parseFloat(this.allocations_from[index].leftto);
				input = parseFloat(this.allocations_from[index].leftto);
			}

			this.allcredits.forEach((r: any) => {
				if (r == pay) {
					pay.selected = true;
					r.selected = true;
				}
			});

			this.allocations_from[index].allocation = input;
		}

		this.updateTotals();
	}

	allocationTo(event: any, rec: any) {
		if (!event) {
			rec.selected = false;
			const index = this.allocations_to.indexOf(rec);
			this.allocations_to.splice(index, 1);

		} else {

			this.alldebits.forEach((r: any) => {
				if (r == rec) {
					rec.selected = true;
					r.selected = true;
				}
			});

			rec.selected = true;
			this.allocations_to.push(rec);
		}

		this.updateTotals();

	}

	checkAllTo(event: any) {
		if (event) {
			this.customer.transactions.forEach((r: any) => {
				r.selected = true;
				this.allocations_to.push(r);
			});
		} else {
			this.customer.transactions.forEach((r: any) => { r.selected = false; });
			this.allocations_to = [];
		}

		this.updateTotals();
	}

	checkAllFrom(event: any) {
		if (event) {
			this.allocations_from = [];
			this.customer.payments.forEach((r: any) => {
				r.selected = true;
				//this.allocations_from.push(r);
				this.allocationFrom(true, r)
			});
		} else {
			this.customer.transactions.forEach((r: any) => {
				r.selected = false;
				this.allocationFrom(false, r)
			});
			this.allocations_from = [];
		}

		this.updateTotals();
	}

	allocationFrom(event: any, rec: any) {
		if (!event) {
			rec.selected = false;
			const index = this.allocations_from.indexOf(rec);
			if (rec.cctrans && rec.payby_comments != '') {
				this.paymentForm.get('checkno').setValue('');
			}

			this.allocations_from.splice(index, 1);
		} else {

			if (rec.cctrans && rec.payby_comments != '') {
				this.paymentForm.get('checkno').setValue(rec.payby_comments);
			}
			rec.selected = true;
			this.allocations_from.push(rec);
		}

		this.updateTotals();

		/*
		if(this.selectInvoiceToPay.value) {
			let amount = this.allocation_from_total + this.allocation_to_total;

			if(amount > 0 ){
				this.paymentForm.get('amount').setValue(amount.toFixed(2));
			} else {
				this.paymentForm.get('amount').setValue(0.00);
			}
		}
		*/
	}

	addAllocations() {
		if (!this.paymentForm.get('debtorno').value) {
			alert('Please Select A Customer');
		} else {
			const data = { from: this.allocations_from, to: this.allocations_to, debtor: this.paymentForm.value }
			this.paymentsService.addAllocations(data).subscribe((result: any) => {

				this.allpayments = result.payments;
				this.alltransactions = result.transactions;

				this.buildBrandOptions();
				this.customer.transactions = result.transactions
				this.customer.payments = result.payments
				this.customer.credits = result.credits
				this.allcredits = result.payments
				this.alldebits = result.transactions
				this.applyInvoiceFilters();
				this.selectAllInvoices.setValue(false);
				this.selectAllPayments.setValue(false);
				this.checkAllTo(false);
				this.checkAllFrom(false);
				this.allocations_to = [];
				this.allocations_from = [];
				this.updateTotals();
			});
		}
	}

	doNotCharge(event: any) {
		event.preventDefault();
		this.payment_card = false;
		this.charge_card = false;
		this.paymentForm.get('charge_card').setValue(false)
		this.profile_cards.every(card => card.default = false);
	}

	addPayment(event: any) {
		event.preventDefault();
		if (!this.paymentForm.get('debtorno').value) {
			alert('Please Select A Customer');
		} else {
			// Surface validation issues instead of silently no-oping. If the form
			// is invalid or the amount is zero, mark fields touched (so mat-errors
			// render) and toast the first concrete blocker.
			if (!this.paymentForm.valid || this.paymentForm.get('amount').value == 0) {
				this.paymentForm.markAllAsTouched();
				let msg = 'Fix the highlighted fields before posting';
				if (!this.paymentForm.get('amount').value || this.paymentForm.get('amount').value == 0) {
					msg = 'Enter a payment amount';
				} else if (!this.paymentForm.get('payment_type')?.value) {
					msg = 'Pick a payment method';
				} else if (this.naEnabled) {
					if (!this.paymentForm.get('na_vendor_id')?.value) msg = 'Pick a backing vendor';
					else if (!this.paymentForm.get('na_gl_account')?.value) msg = 'Pick a relief GL account';
					else if (!this.paymentForm.get('na_credit_amount')?.value) msg = 'Enter a relief amount';
				}
				this.globalSearchService.showNotification(msg, 'warning', 'bottom', 'left');
				return;
			}
			if (this.paymentForm.valid && this.paymentForm.get('amount').value != 0) {

				let charge_card = false;
				switch (this.chargecardtype) {
				case 'no_charge':
					charge_card = false;
					break;
				case 'new_card':
					charge_card = this.cardForm.value
					break;
				case 'existing_card':
					if (this.paymentForm.get('trigger_refund')?.value) {
						charge_card = false;
					} else {
						charge_card = this.selected_card.value;
						if (!this.selected_card.value) {
							alert('Please Select a card');
							return false;
						}
					}
					break;
				}

				if (this.chargecardtype === 'new_card' && charge_card && typeof charge_card === 'object') {
					const z = this.customer?.address5;
					if (z != null && String(z).trim() !== '' && !(charge_card as any).postal_code) {
						(charge_card as any).postal_code = String(z).trim();
					}
				}

				const tagVal = this.paymentForm.get('tag').value;
				const tagId = (tagVal && tagVal.tagId !== undefined) ? tagVal.tagId : (tagVal || '');
				const data: any = {
					payment: this.paymentForm.value,
					charge_card: charge_card,
					from: this.allocations_from,
					to: this.allocations_to,
					debtor: this.paymentForm.value
				};
				if (tagId !== '' && tagId != null) {
					data.tag = tagId;
				}
				//reversed values
				this.submitting = true;

				// Vendor-backed (cross-ledger) flow — operator-toggled via na_enabled.
				// POSTs to the cross-ledger endpoint instead of the regular cash-receipt path.
				// Server posts AR + AP atomically and writes a shared NA reference on both rows.
				if (this.naEnabled) {
					// Conditional validators are attached when na_enabled flips on, so any
					// missing required field shows inline mat-error. Bail with a toast if
					// the operator tries to submit anyway.
					this.paymentForm.markAllAsTouched();
					const naVendor = this.paymentForm.get('na_vendor_id').value;

					// Auto-resolve GL inputs: operators sometimes type a code without
					// clicking an autocomplete option, leaving na_gl_account / na_commission_gl
					// empty even though the visible field looks "set". If what they typed
					// exactly matches a real chartmaster code, treat it as picked.
					this.naResolveTypedGlPick('na_gl_search', 'na_gl_account', 'na_gl_name');
					this.naResolveTypedGlPick('na_comm_gl_search', 'na_commission_gl', 'na_commission_gl_name');

					const naGl     = this.paymentForm.get('na_gl_account').value;
					const naGlSearch = String(this.paymentForm.get('na_gl_search').value || '').trim();
					const naCredit = parseFloat(this.paymentForm.get('na_credit_amount').value || 0);
					const naInvoiceDate = this.paymentForm.get('na_invoice_date').value;
					// Negative relief is legitimate (payout / customer refund via vendor),
					// so allow nonzero. Zero amount and a missing invoice date are the blockers.
					if (!naVendor || isNaN(naCredit) || naCredit === 0 || !naInvoiceDate) {
						this.submitting = false;
						this.globalSearchService.showNotification(
							'Fill in backing vendor, relief amount, and invoice date before posting',
							'danger', 'bottom', 'left'
						);
						return;
					}
					if (!naGl) {
						this.submitting = false;
						const msg = naGlSearch
							? `Relief GL "${naGlSearch}" isn't a valid account — pick one from the dropdown`
							: 'Pick a relief GL account from the dropdown';
						this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'left');
						return;
					}
					// The live check already disables Pay, but a submit fired before the lookup
					// landed would still reach the server — which throws and rolls back the whole
					// payment, AR receipt included. Stop it here instead.
					if (this.naDupCredit) {
						this.submitting = false;
						this.globalSearchService.showNotification(
							'Settlement ref ' + String(this.paymentForm.get('na_vendor_reference').value || '').trim()
							+ ' — already booked',
							'danger', 'bottom', 'left'
						);
						return;
					}

					const naCommAmt = parseFloat(this.paymentForm.get('na_commission_amount').value || 0);
					const naCommGl  = this.paymentForm.get('na_commission_gl').value;
					const naCommGlSearch = String(this.paymentForm.get('na_comm_gl_search').value || '').trim();
					// Signed spread: positive = commission earned, negative = loss the vendor
					// did not fund. Both need a GL to land on, so test the magnitude.
					const naSpreadLabel = naCommAmt < 0 ? 'Loss' : 'Commission';
					if (Math.abs(naCommAmt) > 0.004 && !String(naCommGl || '').trim()) {
						this.submitting = false;
						const msg = naCommGlSearch
							? `${naSpreadLabel} GL "${naCommGlSearch}" isn't a valid account — pick one from the dropdown (or clear the amount)`
							: `${naSpreadLabel} amount is set — pick a ${naSpreadLabel.toLowerCase()} GL from the dropdown (or clear the amount)`;
						this.globalSearchService.showNotification(msg, 'danger', 'bottom', 'left');
						return;
					}

					// Cross-ledger balance check — the AR receipt should equal the vendor
					// relief MINUS the spread: the server derives the receipt as
					// credit_amount - commission_amount and books the vendor credit at the
					// statement amount (relief alone; the spread is house income on a gain
					// and a P&L charge on a loss). Warn on a mismatch so the operator sees
					// what will actually post; the keyed AR amount is not used by the server.
					const arAmt = parseFloat(this.paymentForm.get('amount').value || 0);
					// Signed — a negative spread (loss) raises expectedAr above the relief,
					// which is the point: the receipt must still settle the full invoice.
					// Half-cent deadband so a rounding stub doesn't shift expectedAr past
					// the cent of tolerance below.
					const expectedAr = naCredit - (Math.abs(naCommAmt) > 0.004 ? naCommAmt : 0);
					const gap = Math.round((arAmt - expectedAr) * 100) / 100;
					if (Math.abs(gap) > 0.01) {
						const arStr = arAmt.toFixed(2);
						const vStr = expectedAr.toFixed(2);
						const gapStr = Math.abs(gap).toFixed(2);
						const spreadWord = naCommAmt < 0 ? 'plus loss' : 'minus commission';
						const ok = confirm(
							`AR amount is $${arStr} but relief ${spreadWord} is $${vStr}.\n\n` +
							`The receipt will post at $${vStr} regardless — the keyed AR amount differs by $${gapStr}.\n\n` +
							`Continue anyway? (Cancel to fix the amounts.)`
						);
						if (!ok) {
							this.submitting = false;
							return;
						}
					}

					const naData: any = {
						payment: this.paymentForm.value,
						national_account: {
							vendor_id: naVendor,
							gl_account: naGl,
							credit_amount: naCredit,
							// Signed spread — a negative value is a loss and must reach the
							// server, not be zeroed out here.
							commission_amount: Math.abs(naCommAmt) > 0.004 ? naCommAmt : 0,
							commission_gl_account: Math.abs(naCommAmt) > 0.004 ? naCommGl : '',
							vendor_reference: this.paymentForm.get('na_vendor_reference').value || '',
							invoice_date: this.formatNaPostDate(this.paymentForm.get('na_invoice_date').value),
							due_date: this.formatNaPostDate(this.paymentForm.get('na_due_date').value),
						},
						from: this.allocations_from,
						to: this.allocations_to
					};
					if (tagId !== '' && tagId != null) { naData.tag = tagId; }

					this.paymentsService.nationalAccountPayment(naData).subscribe((result: any) => {
						this.submitting = false;
						if (result?.success) {
							this.single_use = false;
							const ref = result.reference_id || '';
							this.globalSearchService.showNotification(
								`Vendor-backed payment posted (ref ${ref})`, 'success', 'bottom', 'left'
							);
							// Clear the form for the next post. Keep payment_type /
							// bankaccount / debtorno populated — the operator usually
							// posts several to the same lane — and stamp the returned
							// reference onto checkno / description for traceability.
							this.paymentForm.get('amount').setValue('');
							this.paymentForm.get('discount').setValue(0);
							if (ref) {
								this.paymentForm.get('checkno').setValue(ref);
								this.paymentForm.get('description').setValue(ref);
							} else {
								this.paymentForm.get('checkno').setValue('');
							}
							this.resetNaSettlementFields(this.naEnabled);
							this.paymentForm.markAsUntouched();
							this.selectAllInvoices.setValue(false);
							this.allocations_to = [];
							this.allocations_from = [];
							this.allocation_to_total = 0;
							this.allocation_from_total = 0;
							this.loadCustomer();
							this.getJournals();
							this.updateTotals();
							this.getAllUserCurrentOpenJounrals();
							this.focusTo();
						} else {
							this.globalSearchService.showNotification(
								result?.message || 'Vendor-backed payment failed',
								'danger', 'bottom', 'left'
							);
						}
					});
					return;
				}

				this.paymentsService.addCashRecPayment(data).subscribe((result: any) => {
					this.submitting = false;
					if (result.success) {

						// 						this.payment_added = result
						//
						// 						this.allpayments = result.payments;
						// 						this.alltransactions = result.transactions;
						//
						// 						this.customer.payments = result.payments
						// 						this.customer.credits = result.credits
						//
						// 						this.allcredits = result.payments
						// 						this.alldebits = result.transactions

						this.single_use = false;
						this.globalSearchService.showNotification('Payment Added', 'success', 'bottom', 'left');
						this.paymentForm.get('amount').setValue('')
						this.paymentForm.get('discount').setValue(0)
						this.paymentForm.get('checkno').setValue('');
						this.paymentForm.get('trigger_refund').setValue(false);
						this.clearGlOverride();
						this.selected_card.setValue(false);

						this.setCardForm();
						this.loadCustomer();
						this.getJournals();
						this.focusTo();

						this.selectAllInvoices.setValue(false);
						this.allocation_from_total = 0.00;
						this.allocation_to_total = 0.00;
						this.allocations_to = [];
						this.allocations_from = [];

						this.updateTotals();
						this.getAllUserCurrentOpenJounrals();

					} else {
						this.globalSearchService.showNotification('Error: ' + result.message, 'danger', 'bottom', 'left');
					}
				});
			} else {
				this.globalSearchService.getFormValidationErrors(this.paymentForm);
			}
		}
	}

	hidePayments() {
		this.hidepay = (this.hidepay) ? false : true;
	}

	currentPaymentsSearch(value: any) {
		if (value != '') {
			this.customer.payments = this.globalSearchService.filterItem(this.allpayments, value, 'trandate,typename,orderno,transno,total');
		} else {
			this.customer.payments = this.allpayments;
		}
	}


	currentPaymentsSearchDate(value: any) {
		if (value != '') {
			this.customer.payments = this.globalSearchService.filterItem(this.allpayments, value, 'trandate');
		} else {
			this.customer.payments = this.allpayments;
		}

	}

	currentInvoiceSearch(value: any) {
		this.invoiceSearchTerm = (value == null) ? '' : String(value);
		this.applyInvoiceFilters();
	}

	/**
	 * Brand names on a document, for the invoice card. Payments carry no brand, and an
	 * invoice whose items are not mapped to a manufacturer carries none either — both
	 * read as a dash rather than an empty line.
	 */
	brandsDisplay(pay: any): string {
		const v = pay?.brands_display != null ? String(pay.brands_display).trim() : '';
		return v !== '' ? v : '—';
	}

	/**
	 * Brands present on the loaded documents. Rebuilt on every load so a selection that
	 * no longer applies (different customer, invoice paid off) does not silently hide
	 * every row.
	 */
	private buildBrandOptions(): void {
		if (!this.brandFilterEnabled) {
			this.brandOptions = [];
			this.brand_selected = [];
			return;
		}
		const seen = new Map < number, string > ();
		const rows = Array.isArray(this.alltransactions) ? this.alltransactions : [];
		rows.forEach((t: any) => {
			const brands = Array.isArray(t?.brands) ? t.brands : [];
			brands.forEach((b: any) => {
				const id = Number(b?.id) || 0;
				const name = b?.name != null ? String(b.name).trim() : '';
				if (id > 0 && name !== '' && !seen.has(id)) {
					seen.set(id, name);
				}
			});
		});
		this.brandOptions = Array.from(seen, ([id, name]) => ({ id, name }))
			.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
		this.brand_selected = (this.brand_selected || []).filter((id: any) => seen.has(Number(id)));
	}

	/**
	 * Text search and brand filter are applied together — picking a brand while a search
	 * term is typed must not throw the term away, and vice versa. Rows are the same object
	 * references as `alltransactions`, so a filtered-out invoice keeps its typed allocation.
	 */
	private applyInvoiceFilters(): void {
		let rows = Array.isArray(this.alltransactions) ? this.alltransactions : [];
		if (this.invoiceSearchTerm !== '') {
			rows = this.globalSearchService.filterItem(rows, this.invoiceSearchTerm, 'trandate,typename,transno,orderno,total,brands_display');
		}
		if (this.brandFilterEnabled && (this.brand_selected || []).length) {
			const wanted = new Set((this.brand_selected || []).map((id: any) => Number(id)));
			rows = rows.filter((r: any) => {
				const ids = Array.isArray(r?.brand_ids) ? r.brand_ids : [];
				return ids.some((id: any) => wanted.has(Number(id)));
			});
		}
		this.customer.transactions = rows;
	}

	brandFilterChange(): void {
		this.applyInvoiceFilters();
	}

	currentInvoiceSearchDate(value: any) {

		if (value != '') {
			this.customer.transactions = this.globalSearchService.filterItem(this.alltransactions, value, 'trandate');
		} else {
			this.customer.transactions = this.alltransactions;
		}

	}

	togglePaySelect(pay: any) {
		pay.selected = (pay.selected) ? false : true;
		if (pay.selected) {
			this.creditsSelected.push(pay)
		} else {
			const i = this.creditsSelected.indexOf(pay)
			this.creditsSelected.splice(i, 1);
		}
	}

	updateDayPayMents(event: any) {
		this.today = event;
		this.paymentsService.getPayments(this.today.toISOString()).subscribe((results: any) => {
			this.payments = results;
		});
	}

	selectCustomer(customer: any) {
		//todo dont do this


		this.customersearching = false;
		this.customerSearchInline.setValue(customer.name);
		this.customer = customer;
		this.loadCustomer();
		//this.router.navigate(['/receivables/payment-entry/' + customer.debtorno + '/' + customer.branchcode]);
	}

	customerSearchtwo(event: any) {

		if (this.customersearching) {
			this.customersearching.unsubscribe()
		}

		const search = {
			keywords: event
		}

		this.customersearching = this.customerService.getCustomerSearch(search).subscribe(async (results: any) => {
			this.customerSearchResultsTwo = results;

			if (results.length == 1) {
				this.selectCustomer(results[0])
				this.customerSearchResults = false;
				this.customerSearchResultsTwo = false;
			}

		});
	}

	overShort(): number {
		const balance = (this.financial(this.allocation_to_total) + this.financial(this.allocation_from_total));
		return balance;
	}

	applyAmount(): number {

		let balance = (this.financial(this.allocation_to_total) + this.financial(this.allocation_from_total));

		if (balance > 0) {
			balance = this.financial(this.allocation_to_total)
		}
		// if (balance >= 0) {
		// 	balance = 0.00
		// }
		return balance;
	}

	paymentTotals(): number {
		if (this.naEnabled) {
			const ar = this.naArTarget();
			const receipt = parseFloat(this.paymentForm.get('amount')?.value || 0) || 0;
			return this.financial(ar - receipt);
		}

		let balance = (this.financial(this.allocation_to_total) + this.financial(this.allocation_from_total));

		if (balance > 0) {
			balance = this.financial(this.allocation_from_total)
		}
		return balance;
	}

	ngOnDestroy(): void {
		if (this.naEnabledSub) {
			this.naEnabledSub.unsubscribe();
		}
		if (this.naVendorSearchSub) {
			this.naVendorSearchSub.unsubscribe?.();
		}
		if (this.naRefCheckSub) {
			this.naRefCheckSub.unsubscribe?.();
			this.naRefCheckSub = null;
		}
	}

	ngAfterViewInit(): void {
		this.getJournals();
		this.consumePendingMemo();
	}

	singleFormSet(event: any) {


	}

	editCard(event: any, card: any) {
		event.stopPropagation();
		event.preventDefault();

		this.editingcard = true;
		this.cardForm = this.fb.group({
			debtorno: [this.customer.debtorno, Validators.required],
			branchcode: [this.customer.branchcode, Validators.required],
			name: [card.name, Validators.required],
			ccnumber: [card.number, Validators.required],
			card_id: [card.card_id, Validators.required],
			expiry: [card.expiry_month + '/' + card.expiry_year, Validators.required],
			cvv: ['', Validators.required],
			savetoprofile: [this.globalSearchService.getSaveToProfileDefault(), Validators.required]
		});

	}

	saveCard(event: any) {
		event.stopPropagation();
		event.preventDefault();

		if (this.cardForm.valid) {
			this.sending = true;
			this.paymentsService.addCreditCard(this.cardForm.value).subscribe((result: any) => {
				this.sending = false;
				//todo hunt this down hairlines payment adapter not returning true / false
				if(result.message === 'Successful.') {
					result.success = true;

				}

				if (!result.success) {
					alert(result.message)
				} else {

					if (result.cards) {
						this.hasprofile = true;
						this.profile_cards = result.cards
						this.payment_card = result.cards.filter((card: any) => {
							return card.default
						})[0];
					} else {
						this.hasprofile = true;
						this.loadProfile(this.customer.debtorno, this.customer.branchcode);
					}
					this.chargecardtype = ''
					this.setCardForm();
					this.editingcard = false;
				}
			});
		}

	}

	updateCard(event: any) {
		event.stopPropagation();
		event.preventDefault();

		if (this.cardForm.valid) {
			this.sending = true;
			this.paymentsService.editCreditCard(this.cardForm.value).subscribe((result: any) => {
				this.sending = false;
				if (!result.success) {
					alert(result.message)
				} else {

					if (result.cards) {
						this.hasprofile = true;
						this.profile_cards = result.cards
						this.payment_card = result.cards.filter((card: any) => {
							return card.default
						})[0];


					}

					this.editingcard = false;
				}
			});
		}

	}

	removeCard(event: any) {

		event.stopPropagation();
		event.preventDefault();
		const proceed = confirm('Remove Credit Card From Profile?');
		if (proceed) {
			this.sending = true;
			this.paymentsService.removeCreditCard(this.cardForm.value).subscribe((result: any) => {
				this.sending = false;
				this.hasprofile = (result.cards.length) ? true : false;
				this.editingcard = false;
				this.profile_cards = result.cards
				this.payment_card = result.cards.filter((card: any) => {
					return card.default
				})[0];
			});
		}
	}

	addPaymentMethod(event: any) {
		event.preventDefault();
		if (this.cardForm.valid) {
			this.sending = true;
			this.paymentsService.addCreditCard(this.cardForm.value).subscribe((result: any) => {
				this.sending = false;
				if (!result.success) {
					alert(result.message)
				} else {}
			});
		}
	}
	setChargeCardType(event: any) {
		if (event.value) {
			this.chargecardtype = event.value
		}
	}

	setChargeType(event: any) {
		if (event.value) {
			this.chargetype = event.value
			this.updatePaymentType(event.value)
			this.setCardRequired(event.value);
		}

	}

	openRefundables() {
		this.refundableSelectIndex = -1;
		this.refundablePaymentSearch.setValue('');
		this.refundablesLoading = true;
		this.setFilteredRefundablesTable([]);
		this.modalService.open(this.refundablesFormRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' });
		this.paymentsService.getRefundables(this.customer.debtorno).subscribe({
			next: (result: any[]) => {
				this.refundablesLoading = false;
				this.refundablePayments = Array.isArray(result) ? result : [];
				this.setFilteredRefundablesTable(this.refundablePayments);
			},
			error: () => {
				this.refundablesLoading = false;
				this.refundablePayments = [];
				this.setFilteredRefundablesTable([]);
			}
		});
	}

	onRefundableSearchInput() {
		this.refundableSelectIndex = -1;
		const search = (this.refundablePaymentSearch.value || '').trim();
		if (search === '') {
			this.setFilteredRefundablesTable(this.refundablePayments);
		} else {
			this.setFilteredRefundablesTable(
				this.globalSearchService.filterItem(this.refundablePayments, search, 'response_id,transno,card,trandate,status,amount')
			);
		}
	}

	selectRefundable(refundable: any, index: number) {
		if (!refundable.canprocess) {
			const proceed = confirm('This transaction is older than 60 days and may need to be processed outside the system. Continue anyway?');
			if (!proceed) {
				return;
			}
		}

		this.refundableSelectIndex = index;
		this.paymentForm.get('amount').setValue(this.financial(-1 * refundable.amount));
		this.paymentForm.get('discount').setValue(0);
		this.paymentForm.get('checkno').setValue(refundable.response_id);
		this.chargecardtype = 'existing_card';
		this.paymentForm.get('process_transaction').setValue('existing_card');
		this.paymentForm.get('trigger_refund').setValue(true);
		this.modalService.dismissAll();
	}

	selectText(event: FocusEvent) {
		const input = event.target as HTMLInputElement;
		if (input) {
			setTimeout(() => {
				input.select();
			}, 0);
		}
	}

	setFilteredRefundablesTable(refundables: any[]) {
		this.filteredRefundablePayments = new MatTableDataSource(refundables);
	}

	back() {
		//this.location.back()
	}
	//todo dont do this.
	focusTo() {
		setTimeout(() => {
			this.checknoElement.nativeElement.focus();
		}, 0);
	}

	ngOnChanges(changes: SimpleChanges) {
		this.loadCustomer();
	}
}
